<template>

<app-inner class="cta" :row="true">

    <div class="cta-text">

        {{ text.text }}

    </div>
    
    <div class="cta-button">

        <app-button theme="blue" :text="text.button" :to="{path: text.url}" />

    </div>

</app-inner>

</template>

<script>

export default {

    computed: {

        mode: function() {

            if (this.isSessionBusiness) return 'business';
            if (this.isSessionCustomer) return 'customer';

            return 'guest';

        },

        text: function() {

            return {
                text: this.page['cta_' + this.mode + '_text'],
                button: this.page['cta_' + this.mode + '_button'],
                url: this.page['cta_' + this.mode + '_url']
            }

        }

    }

}

</script>

<style scoped>

.cta {
    background-color: var(--color-grey-light);
    border-radius: 4px;
    padding: 0px 20px;
    align-items: center;
    height: 74px;
    border: 5px solid #fff;
    margin-top: -37px!important;
    z-index: 2;
}

.is-mobile .cta {
    height: auto;
    padding: 10px;
}

.cta-text {
    flex-grow: 1;
    flex-basis: 0;
    font-size: 20px;
    font-weight: 500;
    font-family: grueber, serif;
    color: var(--color-grey-dark);
}

.is-mobile .cta-text {
    font-size: 16px;
}

.cta-button {
    flex-shrink: 0;
}

</style>
